module.exports = __webpack_public_path__ + "static/media/parallax1.14dfd644.jpg";